// extracted by mini-css-extract-plugin
module.exports = {"brandMessageContent":"lv","brandHeader":"mv","emailLabel":"nv","emailValidationError":"ov"};